import React from "react";
import {
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CModalFooter,
} from "@coreui/react";
import AdminTable from "src/pages/Administrator/Helpers/AdminTable";
import { DatePicker, Flex, Input, Select, Typography } from "antd";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useState } from "react";
import {
  addAbonement,
  editAbonement,
  getAbonementsClient,
  getFrHistory,
  getPhoneChangesClub,
} from "src/store/Slices/ClientsSlice";
import { openNotification } from "src/components/helpers/notification";
import { useEffect } from "react";

const NumberChangesShowModal = ({
  visible,
  setVisible,
  clubInfo,
  clubId,
  title,
  page,
  pageSize,
  setPage,
  setPageSize,
  handleTableChange,
  onClickRowOne,
}) => {
  // HELPERS
  const dispatch = useDispatch();

  // STATE
  const [numNum, setNumNum] = useState(null);

  // FUNCTIONS

  useEffect(() => {
    if (visible) {
      dispatch(
        getPhoneChangesClub({
          clubId: clubId,
        })
      ).then((result) => {
        // result.payload or result.value — check your thunk return
        setNumNum(result.payload || result.value || result);
      });
    }
  }, [visible, clubId, clubInfo, dispatch]);
  return (
    <CModal
      size="xl"
      //   sx={{ height: "1000px" }}
      alignment="center"
      visible={visible}
      aria-labelledby="VerticallyCenteredExample"
      onClose={() => {
        setVisible(false);
      }}
      keyboard={true}
    >
      <CModalHeader>
        <CModalTitle id="VerticallyCenteredExample">
          {"История изменения номера телефона"}
        </CModalTitle>
      </CModalHeader>
      <CModalBody
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Flex vertical gap={16} style={{ marginTop: "20px" }}>
          <AdminTable
            scroll={{ x: 0, y: 400 }}
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            onChange={handleTableChange}
            // loading={getAbonementsClientListLoading}
            // onClickRowOne={onClickRowOne}
            columns={numNum}
            rows={numNum?.data?.value?.rows}
            total={numNum?.data?.value?.totalCount}
            // title={title}
            // items={items}
          />
        </Flex>
      </CModalBody>
      <CModalFooter>
        <CButton
          onClick={() => {
            setVisible(false);
          }}
          style={{ color: "#fff" }}
          color="secondary"
        >
          Закрыть
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default NumberChangesShowModal;
